import type { OrgSalesAggregation } from "@/lib/ssd/ssdSalesAggregation";

function money(n: number): string {
  return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

function LensCard(props: { label: string; count: number; gross: number; hint: string }) {
  return (
    <div className="min-w-0 rounded-xl border border-gray-200 px-3 py-2 dark:border-zinc-700">
      <div className="text-[11px] uppercase tracking-wide text-gray-500">{props.label}</div>
      <div className="text-lg font-semibold text-gray-900 dark:text-zinc-50">{money(props.gross)}</div>
      <div className="text-xs text-gray-500">
        {props.count} sale{props.count === 1 ? "" : "s"} · {props.hint}
      </div>
    </div>
  );
}

export function AudienceDataAggregationStrip(props: { aggregation: OrgSalesAggregation | null }) {
  if (!props.aggregation || props.aggregation.lens === "none") return null;
  const a = props.aggregation;
  const showRetail = a.lens === "retail" || a.lens === "both";
  const showMfg = a.lens === "manufacturing" || a.lens === "both";
  return (
    <div className="grid min-w-0 gap-2 sm:grid-cols-3">
      {showRetail ? (
        <LensCard
          label="Retail"
          count={a.retail.sale_count}
          gross={a.retail.gross_usd}
          hint="this org as the selling dealer"
        />
      ) : null}
      {showMfg ? (
        <LensCard
          label="Manufacturing"
          count={a.manufacturing.sale_count}
          gross={a.manufacturing.gross_usd}
          hint="this org as the manufacturer"
        />
      ) : null}
      <LensCard
        label="Combined"
        count={a.combined.sale_count}
        gross={a.combined.gross_usd}
        hint="unique sales this org can see"
      />
    </div>
  );
}
